import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FadeInImage } from '../../../../../../components/FadeInImage';
import {
  SET_PROFILE_FORM_FIELD,
  SET_PROFILE_LAYOUT_TYPE,
} from 'containers/ProfileManager/redux/profile.types';
//----------------------------------------------------------------------------------------
import { GenericCarousel } from 'components/GenericCarousel';
import './style.scss';

export const ProfileImagesCarousel = ({ avatarConfig, isMobile }) => {
  const {
    avatarSelector_access_option_button_leftNavegation: prev,
    avatarSelector_access_option_button_RightNavegation: next,
  } = useSelector(state => state.asset);
  const { prevLayout } = useSelector(state => state.profilesManager);
  const dispatch = useDispatch();

  const handleSelectAvatar = (e, newImage) => {
    e.stopPropagation();
    dispatch({
      type: SET_PROFILE_FORM_FIELD,
      payload: { user_image: newImage },
    });
    dispatch({ type: SET_PROFILE_LAYOUT_TYPE, payload: prevLayout });
  };

  return (
    <div className={'profile-images-carousel'}>
      <div className={'profile-images-carousel__banner'}>
        <div className="profile-images-carousel__banner__collection-img">
          <FadeInImage
            imageSrc={avatarConfig?.user_image}
            imageAlt="cv-collection-img"
            width={'auto'}
            height={'auto'}
            classNames={[
              'profile-images-carousel__banner__collection-img__tag',
            ]}
          />
        </div>
        <GenericCarousel
          classNames={['profile-images-carousel__content']}
          nextArrowIcon={next}
          prevArrowIcon={prev}
          prevIconClassName={'profile-images-carousel__content__prev-btn'}
          nextIconClassName={'profile-images-carousel__content__next-btn'}
          carouselKey={avatarConfig.name}
          spaceBetween={isMobile ? 16 : 24}
        >
          {avatarConfig?.collection?.map((collection, i) => (
            <FadeInImage
              key={`avatar-img-opt-${collection.name}`}
              imageSrc={collection.user_image}
              imageAlt={'cv-avatar-opt'}
              width={144}
              height={144}
              classNames={['profile-images-carousel__avatar']}
              onClick={e => handleSelectAvatar(e, collection.user_image)}
            />
          ))}
        </GenericCarousel>
      </div>
    </div>
  );
};
